<!-- 机构-延时课表 -->
<template>
  <div>
    <div class="index" v-loading="loading" v-show="!teacher_detail.show">
      <div>
        <el-form
          :inline="true"
          :model="queryParams"
          label-width="45px"
          style="margin-top: 20px"
        >
          <el-form-item label="学校">
            <el-select
              v-model="queryParams.school"
              placeholder="请选择"
              class="label"
              filterable
              clearable
            >
              <el-option
                v-for="(item, i) in schoolList"
                :key="i + 'school'"
                :label="item.schoolName"
                :value="item.schoolId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区">
            <el-select
              v-model="queryParams.campus"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in campusList"
                :key="item.org_id + 'xq'"
                :label="item.org_name"
                :value="item.org_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学年学期" label-width="70px">
            <el-select
              v-model="queryParams.semester"
              placeholder="请选择"
              class="label"
              clearable
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <br />
          <div class="d-flex justify-between">
            <div>
              <!-- <el-form-item label="教师">
                <el-select
                  v-model="queryParams.teacher"
                  clearable
                  placeholder="请选择"
                  class="label"
                  filterable
                >
                  <el-option
                    v-for="item in teacherList"
                    :key="item.user_id + 'teacherList'"
                    :label="item.name"
                    :value="item.user_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="周次">
                <el-select
                  v-model="queryParams.week"
                  placeholder="请选择"
                  class="label"
                  @change="getDataList"
                  clearable
                >
                  <el-option
                    v-for="item in weekList"
                    :key="item.id + 'week'"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课程">
                <el-select
                  v-model="queryParams.course"
                  clearable
                  placeholder="请选择"
                  class="label"
                  filterable
                >
                  <el-option
                    v-for="(item, i) in courseList"
                    :key="i + 'course'"
                    :label="item.courseName"
                    :value="item.courseId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="" style="margin-left: 20px">
                <el-button type="primary" size="small" @click="searchFun()"
                  >搜索</el-button
                >
              </el-form-item>
            </div>
            <!-- <p style="color:#606266;font-size:14px;padding-top:15px">样例</p> -->
          </div>
        </el-form>
        <div class="header">
          <div class="header-left">
            <p>
              {{ Userlist.last_top_org_name }}第{{
                queryParams.week || 1
              }}周课表
            </p>
            <div class="btn-box">
              <div
                class="btn-item"
                @click="nextWeekFun(-1)"
                :class="{ no_click: queryParams.week == 1 }"
              >
                <img
                  src="./imgs/left_icon.svg"
                  alt=""
                  style="margin-right: 10px"
                />
                <el-button type="text">上周</el-button>
              </div>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="nextWeekFun(0)"
                :class="{ no_click: !isWeek || queryParams.week == 1 }"
                >本周</el-button
              >
              <div
                class="btn-item"
                @click="nextWeekFun(1)"
                :class="{ no_click: queryParams.week == lastWeek }"
              >
                <el-button type="text" style="margin-left: 20px"
                  >下周</el-button
                >
                <img
                  src="./imgs/right_icon.svg"
                  alt=""
                  style="margin-left: 10px"
                />
              </div>
            </div>
          </div>

          <!-- <el-button style="height:32px" size="small">修改课表</el-button> -->
        </div>

        <!-- 课程表 -->
        <div class="class-table">
          <div class="table-wrapper">
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th class="th-one">
                      <span class="bottom">教师</span>
                      <div class="line"></div>
                      <span class="top">日期</span>
                    </th>
                    <th v-for="(week, index) in weeks" :key="index">
                      {{ week.value + " " }}{{ week.date || "" }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="tableData && Object.keys(tableData).length">
                    <tr v-for="(item, index) in tableData" :key="index">
                      <td>
                        <p>{{ index }}</p>
                      </td>
                      <td v-for="(day, i) in item" :key="'day' + i">
                        <template v-if="day">
                          <!-- <div v-for="(dayCourse,j) in day" :key="'dayCourse'+j" class="td_padding" :class="{'border_top':day.length>1 && j>0, 'border_2':day.length===1 && dayCourse.check}" :style="{'background':dayCourse.backgroundColor}"> -->
                          <div
                            v-for="(dayCourse, j) in day"
                            :key="'dayCourse' + j"
                            class="td_padding"
                            :class="{ border_top: day.length > 1 && j > 0 }"
                          >
                            <el-tooltip
                              v-if="
                                dayCourse.classTimeName &&
                                dayCourse.classTimeName.length > 19
                              "
                              class="item"
                              effect="light"
                              :content="'上课时间: ' + dayCourse.classTimeName"
                              placement="top-end"
                            >
                              <p class="ellipsis" style="color: #4991e1">
                                上课时间：{{ dayCourse.classTimeName }}
                              </p>
                            </el-tooltip>
                            <p
                              class="ellipsis"
                              style="color: #4991e1"
                              v-if="
                                dayCourse.classTimeName &&
                                dayCourse.classTimeName.length < 19
                              "
                            >
                              上课时间：{{ dayCourse.classTimeName }}
                            </p>
                            <p>课程名称：{{ dayCourse.courseName || "无" }}</p>
                            <p
                              v-if="
                                dayCourse.locationName &&
                                dayCourse.locationName != ''
                              "
                            >
                              上课地点：{{ dayCourse.locationName }}
                            </p>
                            <p
                              v-if="
                                dayCourse.selectedCount && dayCourse.totalLimit
                              "
                            >
                              报名数/招生数：{{ dayCourse.selectedCount }}/{{
                                dayCourse.totalLimit
                              }}
                            </p>
                          </div>
                        </template>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <img
                      class="no_data"
                      src="@/assets/img/no_data.svg"
                      alt=""
                    />
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TeacherDetail
      :info="teacher_detail.info"
      v-show="teacher_detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
    ></TeacherDetail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import colorArr from "./td_background.js";
import util from "@/utils/util.js";
import { mapState, mapMutations } from "vuex";
import {
  schoolTeacherList,
  getOrgMemberSimpleList,
} from "@/api/user/userCenter";
import _ from "lodash";
export default {
  components: {
    TeacherDetail: () => import("./teacher_detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        school: "",
        campus: "",
        semester: "",
        course: "",
        teacher: "",
        date: "",
        week: 1,
      },
      isWeek: false,
      campusList: [],
      semesterList: [],
      teacherList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      setting: {
        info: {},
        show: false,
      },
      weeks: [],
      lastWeek: 0,
      tableShow: false,
      Userlist: JSON.parse(sessionStorage.getItem("userInfo")) || {},
      weekList: [
        // {id:1, label:'第1周'},
        // {id:2, label:'第2周'},
        // {id:3, label:'第3周'},
        // {id:4, label:'第4周'},
        // {id:5, label:'第5周'},
        // {id:6, label:'第6周'},
        // {id:7, label:'第7周'},
        // {id:8, label:'第8周'},
        // {id:9, label:'第9周'},
        // {id:10, label:'第10周'},
        // {id:11, label:'第11周'},
        // {id:12, label:'第12周'},
        // {id:13, label:'第13周'},
        // {id:14, label:'第14周'},
        // {id:15, label:'第15周'},
        // {id:16, label:'第16周'},
        // {id:17, label:'第17周'},
        // {id:18, label:'第18周'},
        // {id:19, label:'第19周'},
        // {id:20, label:'第20周'},
      ],
      todayWeek: {},
      nextWeek: 0,
      colorArr: colorArr,
      backgroundObj: {},
      teacher_detail: {
        info: {},
        show: false,
      },
      detail_semester: "",
      loading: false,
      schoolList: [],
      courseList: [],
      semester_obj: {},
      grade_obj: {},
      week_disabled: false,
    };
  },
  computed: {
    ...mapState(["org_time_table"]),
  },
  watch: {
    // 切换学校拉取学期学年信息
    "queryParams.school": function (n, o) {
      if (n) {
        let vm = this;
        this.getSemesterList(n, (data) => {
          if (data.length) {
            vm.semesterList = data.map((v) => ({
              label:
                v.schoolYear +
                "年度" +
                (v.semester === 1 ? "上学期" : "下学期"),
              value: v.schoolYear + "_" + v.semester,
              id: v.id,
              isCurrent: v.isCurrent,
              startDate: v.startDate,
              endDate: v.endDate,
            }));
            let semesterRes = vm.semesterList.filter((e) => e.isCurrent);
            vm.queryParams.semester = semesterRes[0]?.value;
            // let weekObj = util.TodayInfo(semesterRes[0]?.startDate);
            // if(weekObj){
            //     if (weekObj.week > 20){
            //         weekObj.week = 20;
            //         this.week_disabled = true;
            //     }
            //     vm.queryParams.week = weekObj.week || 1;
            //     vm.todayWeek = weekObj;
            // }
          }
        });
        this.getSchoolTeacherList();
        this.getOtherInfo(n, (data) => {
          vm.campusList = data;
        });
        this.searchFun();
      }
    },
    "queryParams.semester": function (n, o) {
      this.getWeekData(n);
      // let semesterRes = this.semesterList.filter(e=>e.value === n);
      // if(semesterRes[0].isCurrent){
      //     this.queryParams.week = this.todayWeek.week || 1;
      // }else{
      //     this.queryParams.week = 1;
      // }
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations(["setOrgTimeTable"]),
    nextWeekFun(type) {
      if (
        (this.queryParams.week == 1 && type == -1) ||
        (this.queryParams.week == this.lastWeek && type == 1)
      )
        return false;
      if (type === 0) {
        // 回到本周
        this.queryParams.semester = this.semesterList.filter(
          (e) => e.isCurrent
        )[0]?.value;
        this.queryParams.week = this.todayWeek.week || 1;
      } else {
        this.queryParams.week += type;
      }
      this.getDataList();
    },
    async init() {
      try {
        this.loading = true;
        // 获取学校下拉框列表
        let schoolRes = await api.getTimeTableSchoolList({
          orgId: sessionStorage.orgId,
        });
        if (schoolRes.code === "0") {
          this.schoolList = schoolRes.data.schoolList || [];
        }
        // 获取课程下拉框列表
        let courseRes = await api.getTimeTableCourseList({
          orgId: sessionStorage.orgId,
        });
        if (courseRes.code === "0") {
          let courseArr = courseRes.data.courseList || [];
          // 数组去重
          let arr2 = [],
            id_arr2 = [];
          for (var i = 0; i < courseArr.length; i++) {
            if (id_arr2.includes(courseArr[i].courseId) == false) {
              id_arr2.push(courseArr[i].courseId);
              arr2.push(courseArr[i]);
            }
          }
          this.courseList = arr2;
        }
        // 给不同课程背景色
        this.backgroundObj = {};
        this.courseList.forEach((item, i) => {
          this.backgroundObj[item.courseName] = this.colorArr[i % 20];
        });
        if (this.schoolList.length) {
          this.queryParams.school = this.schoolList[0].schoolId;
        }
        this.getSchoolTeacherList();
        this.getDataList();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    // 获取学校教师列表
    async getSchoolTeacherList() {
      let teacherRes = await getOrgMemberSimpleList({
        top_org_id: sessionStorage.orgId,
        // top_org_id:this.queryParams.school,
        page: 1,
        page_size: 500,
        user_type: "1,5",
        // need_role: "1",
      });
      if (teacherRes.code === "000000") {
        this.teacherList = teacherRes.result.member_list || [];
      } else {
        this.$message.error("获取老师信息失败");
      }
    },
    async getSemesterList(id, cb) {
      let data = [];
      if (this.semester_obj[id]) {
        data = this.semester_obj[id];
      } else {
        // 获取学年学期
        let semesterRes = await api.getSemesterList({
          orgId: id,
        });
        if (semesterRes.code === "0") {
          data = semesterRes.data;
          this.semester_obj[id] = data;
        }
      }
      if (cb && typeof cb === "function") cb(data);
    },
    // 获取学期周次信息
    async getWeekData(semester) {
      this.weekList = [];
      let res = await api.getWeekInfo({
        orgId: this.queryParams.school || "",
        schoolYearSemester: semester || this.queryParams.semester,
      });
      if (res.code === "0") {
        if (res.data.length > 0) {
          //获取最后一周为第几周
          this.lastWeek = res.data[res.data.length - 1].weekNum || 0;
          res.data.forEach((it) => {
            this.weekList.push({
              id: it.weekNum,
              label: `第${it.weekNum}周 (${it.startDate.date.slice(
                0,
                10
              )}至${it.endDate.date.slice(0, 10)})`,
            });
          });
          //判断今天是不是本周次内
          this.isWeek = util.isWeekInData(res.data);
        } else {
          this.queryParams.week = null;
        }
      }
    },
    async getDataList() {
      try {
        this.loading = true;
        let params = {
          extOrgId: sessionStorage.orgId,
          orgId: this.queryParams.school,
          schoolYearSemester: this.queryParams.semester,
          weekNum: this.queryParams.week,
          campusId: this.queryParams.campus,
          courseId: this.queryParams.course,
          teacherId: this.queryParams.teacher,
        };
        var { code, data } = await api.handleTimetable(params);
        console.log("获取延时课表--机构---", code, data);
        if (code == "0" && data) {
          for (let key in data.timetableMap) {
            let item = data.timetableMap[key];
            let check = this.checkDataLength(item);
            for (let i in item) {
              let item_1 = item[i];
              if (item_1 && item_1.length) {
                for (let j in item_1) {
                  item_1[j].check = check;
                  if (this.backgroundObj[item_1[j].courseName]) {
                    item_1[j].backgroundColor =
                      this.backgroundObj[item_1[j].courseName];
                  } else {
                    this.backgroundObj[item_1[j].courseName] =
                      this.colorArr[(i / 1 + j / 1) % 20];
                    item_1[j].backgroundColor =
                      this.backgroundObj[item_1[j].courseName];
                  }
                }
              }
            }
          }
          this.weeks = data.weeks;
          this.filterWeeks(this.weeks);
          this.tableData = this.filterParams(data.timetableMap);

          console.log("课程表数据---", this.tableData);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    filterParams(obj) {
      for (let key in obj) {
        if (Object.keys(obj[key]).length == 0) {
          delete obj[key];
        }
      }
      return obj;
    },

    //解决接口返回没有日期时进行补充
    filterWeeks(weeks) {
      var oneDayTime = 24 * 60 * 60 * 1000;
      let haveValue = weeks.find((it) => {
        return it.date;
      });
      weeks.forEach((it) => {
        if (!it.date) {
          if (it.key > haveValue.key) {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() +
                oneDayTime * (it.key - haveValue.key)
            );
          } else {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() -
                oneDayTime * (haveValue.key - it.key)
            );
          }
        }
      });
    },
    checkDataLength(item) {
      let check = false;
      for (let i in item) {
        if (item[i] && item[i].length > 1) {
          check = true;
        }
      }
      return check;
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toStatistical(item, type) {
      this.teacher_detail.info = item;
      this.teacher_detail.show = true;
    },
    toIndex() {
      this.teacher_detail.show = false;
    },
    async getOtherInfo(id, cb) {
      let data = [];
      if (this.grade_obj[id]) {
        data = this.grade_obj[id];
      } else {
        // 获取年级信息
        let gradeRes = await api.Teacherclass({
          org_id: id,
        });
        if (gradeRes.code === "000000") {
          let gradeResData = gradeRes.result.list || [];
          data = _.groupBy(gradeResData, "org_type")["3"];
          this.grade_obj[id] = data;
        }
      }
      if (cb && typeof cb === "function") cb(data);
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    width: 100%;
    height: 50px;
    border-radius: 3px;
    background: #eff6ff;
    border: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    font-size: 14px;
    .header-left {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        color: #000;
      }
    }
    .btn-box {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .btn-item {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .no_click {
        opacity: 0.3;
        cursor: not-allowed !important;
        button {
          cursor: not-allowed !important;
        }
      }
    }
    .sort {
      margin-left: 30px;
      span {
        margin-right: 20px;
        color: #8b8b8b;
      }
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 200px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .BoxBorder {
    border-bottom: 1px solid #eee;
  }
  .BoxBgColor1 {
    background: #fefcf8;
  }
  .BoxBgColor2 {
    background: #f8fefa;
  }
  .BoxBgColor3 {
    background: #f8f8fe;
  }
  .BoxBgColor4 {
    background: #fef8f9;
  }

  .class-table {
    table,
    table tr th,
    table tr td {
      border: 1px solid #ddd;
      // padding: 5px;
      .td_padding {
        padding: 5px;
        .ellipsis {
          // 省略号
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    table {
      min-height: 25px;
      line-height: 25px;
      text-align: center;
      border-collapse: collapse;
    }
    .table-wrapper {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
    .table-container {
      table {
        table-layout: fixed;
        width: 100%;

        thead {
          background-color: #fff;
          th {
            font-weight: bold;
            font-size: 14px;
            color: #000;
          }
          .th-one {
            width: 110px;
            height: 50px;
            position: relative;
            .line {
              position: absolute;
              width: 1px;
              height: 120px; /*这里需要自己调整，根据td的宽度和高度*/
              top: 0;
              left: 0;
              background-color: #dddddd;
              transform: rotate(-65deg); /*这里需要自己调整，根据线的位置*/
              transform-origin: top;
            }
            .top {
              position: absolute;
              color: #9b9b9b;
              right: 10px;
              top: 10px;
            }
            .bottom {
              position: absolute;
              color: #9b9b9b;
              left: 10px;
              bottom: 10px;
            }
          }
        }
        tbody {
          td {
            // border: 1px solid #ddd;
            text-align: center;
            color: #555;
          }
        }

        tr td:first-child {
          font-weight: bold;
          font-size: 14px;
          color: #000;
          .period {
            font-size: 8px;
          }
        }
        .border_top {
          border-top: 1px solid #ddd;
        }
        // .border_2{
        //     border-top: 1px solid #ddd;
        //     border-bottom: 1px solid #ddd;
        // }
        .point {
          cursor: pointer;
        }
      }
    }
  }

  .no_data {
    margin: 100px 350px;
  }
}
</style>
